import "antd/es/typography/style";
import _Typography from "antd/es/typography";
import React from 'react';

var isNeedTranText = function isNeedTranText(item) {
  var _item$valueType;

  if (item === null || item === void 0 ? void 0 : (_item$valueType = item.valueType) === null || _item$valueType === void 0 ? void 0 : _item$valueType.toString().startsWith('date')) {
    return true;
  }

  if ((item === null || item === void 0 ? void 0 : item.valueType) === 'select' || (item === null || item === void 0 ? void 0 : item.valueEnum)) {
    return true;
  }

  return false;
};
/**
 * 生成 Copyable 或 Ellipsis 的 dom
 *
 * @param dom
 * @param item
 * @param text
 */


export var genCopyable = function genCopyable(dom, item, text) {
  if (item.copyable || item.ellipsis) {
    var copyable = item.copyable && text ? {
      text: text,
      tooltips: ['', '']
    } : undefined;
    /** 有些 valueType 需要设置copy的为string */

    var needTranText = isNeedTranText(item);
    var ellipsis = item.ellipsis && text ? {
      tooltip: needTranText ? /*#__PURE__*/React.createElement("div", {
        className: "pro-table-tooltip-text"
      }, dom) : text
    } : false;
    return /*#__PURE__*/React.createElement(_Typography.Text, {
      style: {
        width: '100%',
        margin: 0,
        padding: 0
      },
      title: "",
      copyable: copyable,
      ellipsis: ellipsis
    }, dom);
  }

  return dom;
};